/* eslint-disable no-console */
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import notify, { MESSAGES } from '../../utils/notify';
import dayjs from 'dayjs';
import classnames from 'classnames';
import 'react-quill/dist/quill.snow.css';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';
import { useParams, useNavigate } from 'react-router-dom';
import SupportDocumentTab from './SupportDocumentTab';
import RequirementTab from './RequirementTab';
import ConfirmInvitationModal from './component/ConfirmInvitationModal';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';
import logger from '../../utils/logger';
import { registerLocale } from 'react-datepicker';
import id from 'date-fns/locale/id';
import {
  displayValue,
  formatSubmittedDate,
  getProcurementStatusConfig,
} from './utils/hpsHelpers';
import ActionButton from '../../Components/Common/ActionButton';
import { DetailBackButton } from '../../Components/Common/Detail';
import { Skeleton, SkeletonCard } from '../../Components/Common/Skeleton';
import useAsyncAction from '../../Components/Hooks/useAsyncAction';
import StatusBadge from '../../Components/Common/StatusBadge';

registerLocale('id', id);
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const InvitationEvaluationForm = () => {
  const [passedSteps, setPassedSteps] = useState([1]);
  const navigate = useNavigate();
  const token = getAuthToken();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcurementLoading, setIsProcurementLoading] = useState(true);
  const [activeTab, setactiveTab] = useState(1);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [ids] = useState(useParams().id);
  const [qtyDeliveryData, setQtyDeliveryData] = useState({ items: [] });
  const [dataCause, setDataCause] = useState({
    items: [],
  });
  const [confirmModal, setConfirmModal] = useState(false);
  const { user } = useSelector(state => state.Login);
  const loggedInUserName = user?.displayName || '';
  const loggedInEmail = user?.email || '';
  const loggedInJobTitle = user?.position || '';

  const LoadDefault = () => {
    fetchDataProcurement(ids, setForm, token);
  };

  const [form, setForm] = useState({
    procurementNumber: '',
    statusProcurement: '',
    titleProcurement: '',
    description: '',
    procurementType: '',
    procurementTypeHeaderLabel: '',
    contractType: '',
    contractPeriodSpot: '',
    contractPeriodTermStart: '',
    contractPeriodTermEnd: '',
    productTypeId: '',
    productType: '',
    productName: '',
    productNameId: '',
    operationalTolerance: '',
    productSpecification: '',
    ratioLpgId: '',
    ratioLpg: '',
    refPropaneFrequency: null,
    refPropaneRangeQuantityFrom: null,
    refPropaneRangeQuantityTo: null,
    refButaneFrequency: null,
    refButaneRangeQuantityFrom: null,
    refButaneRangeQuantityTo: null,
    notesForQuantityAndDeliveryTerms: '',
    quantityDiscrepancy: '',
    delayPenaltyTerms: '',
    delivery: '',
    nominationProcedure: '',
    firstTimeSupply: '',
    redChannelPolicy: '',
    deliveryCustom: '',
    invoicingQuantityId: '',
    invoicingQuantity: '',
    modeInvoicingQuantityId: '',
    modeInvoicingQuantity: '',
    delayPenaltyAmount: null,
    descriptionOfDelayPenaltyTerms: '',
    descriptionOfPaymentTerms: '',
    paymentCurrencyId: '',
    paymentCurrency: '',
    lawId: '',
    law: '',
    arbitrationId: '',
    arbitration: '',
    notesForLoadingPort: '',
    otherTermsAndCondition: '',
    additionalNotes: '',
    proposalSubmissionDeadline: '',
    proposalValidityPeriodMax: '',
    fileHasilOptimasiHilir: '',
    filePenetapanHargaDasarImpor: '',
    fileSpesifikasi: '',
    fileGeneralTermsAndConditions: '',
    fileDocumentQ88: '',
    fileDocumentGasFormC: '',
    fileSupporting1: '',
    fileSupporting2: '',
    fileSupporting3: '',
    fileSupporting4: '',
    fileSupporting5: '',
    subStatus: '',
    isInformationAboutDMUTConfirmed: '',
    isAcknowledgedDMUT: '',
    hpsRequestNumber: '',
    hpsRequestDate: '',
    userId: '',
    user: '',
    isProcurementRequirementCompleted: '',
    isSupportingDocumentsCompleted: '',
    isDMUTInvitationCompleted: '',
    isHPSRequestCompleted: '',
    id: '',
    createdBy: '',
    updatedBy: '',
    createdDate: '',
    updatedDate: '',
    isDeleted: '',
    deletedDate: '',
    deletedBy: '',
  });

  useEffect(() => {
    fetchDataProcurement(ids, setForm, token);
  }, [ids, token]);

  const fetchDataProcurement = async (ids, setForm, token) => {
    try {
      const response = await axios.get(`${api.API_URL}/procurement/${ids}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      const data = response;
      setForm({
        procurementNumber: data.procurementNumber || null,
        statusProcurement: data.statusProcurement || null,
        titleProcurement: data.titleProcurement || null,
        description: data.description || null,
        procurementType: data.procurementType || null,
        procurementTypeHeaderLabel: data.procurementTypeHeaderLabel || null,
        contractType: data.contractType || null,
        contractPeriodSpot: data.contractPeriodSpot || null,
        contractPeriodTermStart: data.contractPeriodTermStart || null,
        contractPeriodTermEnd: data.contractPeriodTermEnd || null,
        productTypeId: data.productTypeId || null,
        productType: data.productType || null,
        procurementProductTypes: data.procurementProductTypes || [],
        productName: data.productType?.product?.name || null,
        productNameId: data.productType?.product?.id || null,
        operationalTolerance: data.operationalTolerance || null,
        productSpecification: data.productSpecification || null,
        ratioLpgId: data.ratioLpgId || null,
        ratioLpg: data.ratioLpg || null,
        refPropaneFrequency: data.refPropaneFrequency || null,
        refPropaneRangeQuantityFrom: data.refPropaneRangeQuantityFrom || null,
        refPropaneRangeQuantityTo: data.refPropaneRangeQuantityTo || null,
        refButaneFrequency: data.refButaneFrequency || null,
        refButaneRangeQuantityFrom: data.refButaneRangeQuantityFrom || null,
        refButaneRangeQuantityTo: data.refButaneRangeQuantityTo || null,
        notesForQuantityAndDeliveryTerms:
          data.notesForQuantityAndDeliveryTerms || null,
        quantityDiscrepancy: data.quantityDiscrepancy || null,
        delayPenaltyTerms: data.delayPenaltyTerms || null,
        delivery: data.delivery || null,
        nominationProcedure: data.nominationProcedure || null,
        firstTimeSupply: data.firstTimeSupply || null,
        redChannelPolicy: data.redChannelPolicy || null,
        deliveryCustom: data.deliveryCustom || null,
        invoicingQuantityId: data.invoicingQuantityId || null,
        invoicingQuantity: data.invoicingQuantity || null,
        invitationEventDate: data.invitationEventDate || null,
        invitationStartTime: data.invitationStartTime || null,
        invitationTillEnd: data.invitationTillEnd || null,
        invitationEndTime: data.invitationEndTime || null,
        invitationLocation: data.invitationLocation || null,
        invitationAgenda: data.invitationAgenda || null,
        invitationEvaluationStatus:
          data.invitationEvaluationStatus == 0 ? false : true,
        isDelegate: data.isDelegate == 0 ? 'Present' : 'Delegate',
        invitationDelegateName: data.invitationDelegateName || null,
        invitationDelegateEmail: data.invitationDelegateEmail || null,
        invitationDelegateJobTitle: data.invitationDelegateJobTitle || null,
        modeInvoicingQuantityId: data.modeInvoicingQuantityId || null,
        modeInvoicingQuantity: data.modeInvoicingQuantity || null,

        delayPenaltyAmount: data.delayPenaltyAmount ?? null,
        descriptionOfDelayPenaltyTerms:
          data.descriptionOfDelayPenaltyTerms || null,
        descriptionOfPaymentTerms: data.descriptionOfPaymentTerms || null,
        paymentCurrencyId: data.paymentCurrencyId || null,
        paymentCurrency: data.paymentCurrency || null,
        partyType: data.partyType || null,

        lawId: data.lawId || null,
        law: data.law || null,
        arbitrationId: data.arbitrationId || null,
        arbitration: data.arbitration || null,
        notesForLoadingPort: data.notesForLoadingPort || null,
        otherTermsAndCondition: data.otherTermsAndCondition || null,
        additionalNotes: data.additionalNotes || null,
        proposalSubmissionDeadline: data.proposalSubmissionDeadline
          ? dayjs(data.proposalSubmissionDeadline).toDate()
          : null,
        proposalValidityPeriodMax: data.proposalValidityPeriodMax
          ? dayjs(data.proposalValidityPeriodMax).toDate()
          : null,
        fileHasilOptimasiHilir: data.fileHasilOptimasiHilir || null,
        filePenetapanHargaDasarImpor: data.filePenetapanHargaDasarImpor || null,
        fileSpesifikasi: data.fileSpesifikasi || null,
        fileGeneralTermsAndConditions:
          data.fileGeneralTermsAndConditions || null,
        fileDocumentQ88: data.fileDocumentQ88 || null,
        fileDocumentGasFormC: data.fileDocumentGasFormC || null,
        fileSupporting1: data.fileSupporting1 || null,
        fileSupporting2: data.fileSupporting2 || null,
        fileSupporting3: data.fileSupporting3 || null,
        fileSupporting4: data.fileSupporting4 || null,
        fileSupporting5: data.fileSupporting5 || null,
        subStatus: data.subStatus || null,
        isInformationAboutDMUTConfirmed:
          data.isInformationAboutDMUTConfirmed || null,
        isAcknowledgedDMUT: data.isAcknowledgedDMUT || null,
        hpsRequestNumber: data.hpsRequestNumber || null,
        hpsRequestDate: data.hpsRequestDate || null,
        userId: data.userId || null,
        user: data.user || null,
        isProcurementRequirementCompleted:
          data.isProcurementRequirementCompleted || null,
        isSupportingDocumentsCompleted:
          data.isSupportingDocumentsCompleted || null,
        isDMUTInvitationCompleted: data.isDMUTInvitationCompleted || null,
        isHPSRequestCompleted: data.isHPSRequestCompleted || null,
        id: data.id || null,
        createdBy: data.createdBy || null,
        updatedBy: data.updatedBy || null,
        createdDate: data.createdDate || null,
        updatedDate: data.updatedDate || null,
        isDeleted: data.isDeleted || null,
        deletedDate: data.deletedDate || null,
        deletedBy: data.deletedBy || null,
        noNotaDinas: data.noNotaDinas || null,
        statusHPS2: data.statusHPS2 ?? data.StatusHPS2 ?? 0,
      });
      const quantityItems = (data.procurementClauseDetails || []).map(item => ({
        id: item.id ?? null,
        procurementId: item.procurementId ?? null,
        clauseDetailId: item.clauseDetailId ?? null,
        clauseTitle: item.clauseTitle ?? null,
        ordreNumber: item.ordreNumber ?? null,
        isShow: item.isShow ?? null,
        isActive: item.isActive ?? null,
        clauseDescription: item.clauseDescription ?? null,
        isShowToDMUT: item.isShowToDMUT ?? null,
      }));
      setDataCause({ items: quantityItems });
    } catch (error) {
      logger.error('Error fetching data from  API:', error);
    } finally {
      setIsProcurementLoading(false);
    }
  };

  const selectedFields = {
    contractType: form.contractType,
    contractPeriodSpot: form.contractPeriodSpot,
    contractPeriodTermStart: form.contractPeriodTermStart,
    contractPeriodTermEnd: form.contractPeriodTermEnd,
    productTypeId: form.productTypeId, // <- Diperbaiki
    operationalTolerance: form.operationalTolerance,
    productSpecification: form.productSpecification,
    ratioLpgId: form.ratioLpgId,
    refPropaneFrequency: form.refPropaneFrequency,
    refPropaneRangeQuantityFrom: form.refPropaneRangeQuantityFrom,
    refPropaneRangeQuantityTo: form.refPropaneRangeQuantityTo,
    refButaneFrequency: form.refButaneFrequency,
    refButaneRangeQuantityFrom: form.refButaneRangeQuantityFrom,
    refButaneRangeQuantityTo: form.refButaneRangeQuantityTo,
    notesForQuantityAndDeliveryTerms: form.notesForQuantityAndDeliveryTerms,
    quantityDiscrepancy: form.quantityDiscrepancy,
    delayPenaltyTerms: form.delayPenaltyTerms,
    delivery: form.delivery,
    nominationProcedure: form.nominationProcedure,
    firstTimeSupply: form.firstTimeSupply,
    redChannelPolicy: form.redChannelPolicy,
    deliveryCustom: form.deliveryCustom,
    invoicingQuantityId: form.invoicingQuantityId,
    modeInvoicingQuantityId: form.modeInvoicingQuantityId,
    delayPenaltyAmount: form.delayPenaltyAmount,
    descriptionOfDelayPenaltyTerms: form.descriptionOfDelayPenaltyTerms,
    descriptionOfPaymentTerms: form.descriptionOfPaymentTerms,
    paymentCurrencyId: form.paymentCurrencyId,
    lawId: form.lawId,
    arbitrationId: form.arbitrationId,
    notesForLoadingPort: form.notesForLoadingPort, // <- Diperbaiki
    otherTermsAndCondition: form.otherTermsAndCondition,
    additionalNotes: form.additionalNotes,
    proposalSubmissionDeadline: form.proposalSubmissionDeadline,
    proposalValidityPeriodMax: form.proposalValidityPeriodMax,
    fileHasilOptimasiHilir: form.fileHasilOptimasiHilir,
    filePenetapanHargaDasarImpor: form.filePenetapanHargaDasarImpor,
    fileSpesifikasi: form.fileSpesifikasi,
    fileGeneralTermsAndConditions: form.fileGeneralTermsAndConditions,
    fileDocumentQ88: form.fileDocumentQ88,
    fileDocumentGasFormC: form.fileDocumentGasFormC,
    fileSupporting1: form.fileSupporting1,
    fileSupporting2: form.fileSupporting2,
    fileSupporting3: form.fileSupporting3,
    fileSupporting4: form.fileSupporting4,
    fileSupporting5: form.fileSupporting5,
    subStatus: form.subStatus,
    isInformationAboutDMUTConfirmed: form.isInformationAboutDMUTConfirmed,
    isAcknowledgedDMUT: form.isAcknowledgedDMUT,
    hpsRequestDate: form.hpsRequestDate,
    userId: form.userId,
    isProcurementRequirementCompleted: form.isProcurementRequirementCompleted,
    isSupportingDocumentsCompleted: form.isSupportingDocumentsCompleted,
    isDMUTInvitationCompleted: form.isDMUTInvitationCompleted,
    isHPSRequestCompleted: form.isHPSRequestCompleted,
  };

  const handleSaveDraftProc = async () => {
    if (validatedeliveryModal()) {
      try {
        await axios.put(`${api.API_URL}/procurement/${ids}`, selectedFields, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        setError(error.message);
      } finally {
        notify.success(MESSAGES.saved);
        LoadDefault();
      }
    }
  };

  const validatedeliveryModal = () => {
    let tempErrors = {};
    if (!form.productTypeId) {
      tempErrors.productTypeId = 'Please Select';
    }
    if (!form.productNameId) {
      tempErrors.productNameId = 'Please Select';
    }
    if (!form.contractPeriodTermStart) {
      tempErrors.contractPeriodTermStart = 'Please Enter Date';
    }
    if (!form.contractPeriodTermEnd && parseInt(form.contractType, 10) === 1) {
      tempErrors.contractPeriodTermEnd = 'Please Enter Date';
    }
    if (Object.keys(tempErrors).length !== 0) {
      notify.warning(MESSAGES.mandatory);
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const fetchQtyDeliveryList = useCallback(async () => {
    if (!ids) {
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${api.API_URL}/quantity-delivery?ProcurementId=${ids}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP error: ${response.status} ${response.statusText}`
        );
      }

      const result = await response.json();
      if (!result.data?.items) {
        logger.warn('No items found in response');
        return;
      }
      const items = result.data.items.map(item => ({
        procurementId: item.procurementId,
        ratioLpgId: item.ratioLpgId,
        ratioName: item.ratioLpg?.ratioName ?? null,
        deliveryUnit: item.deliveryUnit,
        frequency: item.frequency,

        pricingPeriod: item.pricingPeriod,
        indexPricename: item.indexPrice?.name ?? null,
        otherIndexPricename: item.otherIndexPrice?.name ?? null,
        startDatePublishIndex: item.startDatePublishIndex,
        endDatePublishIndex: item.endDatePublishIndex,
        schemaBL: item.schemaBL,
        notesForPricing: item.notesForPricing,
        isCorrelationBetweenTwoIndex: item.isCorrelationBetweenTwoIndex,
        id: item.id,
      }));
      setQtyDeliveryData({ items });
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [ids, token]);

  useEffect(() => {
    fetchQtyDeliveryList();
  }, [fetchQtyDeliveryList]);

  document.title = `Procurement Requirement - ${form.procurementNumber}`;
  const categoryLabel = form.procurementTypeHeaderLabel || 'Product Hydro';
  const statusConfig = getProcurementStatusConfig(
    form?.invitationEvaluationStatus
  );

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  }

  const handleConfirmProcess = () => {
    setConfirmModal(true);
  };

  const handleSaveConfirmed = async (releaseIds, participation) => {
    const body = {
      isDelegate: participation.mode,
      invitationDelegateName: participation.mode
        ? participation.name
        : loggedInUserName,
      invitationDelegateEmail: participation.mode
        ? participation.email
        : loggedInEmail,
      invitationDelegateJobTitle: participation.mode
        ? participation.jobTitle
        : loggedInJobTitle,
    };
    try {
      const response = await axios.put(
        `${api.API_URL}/procurement/invitation-evaluation-submit/${releaseIds}`,
        body,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      logger.log('Response:', response.data);
    } catch (error) {
      logger.error('Error submit procurement:', error.message);
      throw error;
    }
  };

  const [handleConfirmInvitation, isConfirming] = useAsyncAction(
    async participation => {
      try {
        await handleSaveConfirmed(ids, participation);
        setConfirmModal(false);
        notify.success('Invitation confirmed successfully.');
        LoadDefault();
      } catch (error) {
        notify.apiError(error, 'confirm invitation');
      }
    }
  );

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1 '>
            <div className='email-content minimal-border'>
              <div className='p-4 pb-0'>
                <Row className='mt-n2 mb-1 mb-sm-0'>
                  <div className='col-sm order-3 order-sm-2'>
                    <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                      <h5 className='card-title mb-0 flex-grow-1'>
                        <PageBreadcrumb
                          fallback={{
                            label: 'Invitation Evaluation',
                            to: '/apps-evaluation-invitation/view',
                          }}
                          current={`Detail #${displayValue(form?.procurementNumber)}`}
                          listClassName='p-3 py-2 bg-light'
                        />
                      </h5>
                    </div>
                  </div>
                </Row>
                <Row className='mb-4'>
                  <Col xs={12}>
                    <Row className='align-items-center g-3'>
                      <Col xs={12} lg>
                        <div>
                          <div className='dt-header__top'>
                            <DetailBackButton
                              label='Back to list'
                              onClick={() =>
                                navigate('/apps-evaluation-invitation/view')
                              }
                            />
                            {!isProcurementLoading && (
                              <StatusBadge
                                tone={statusConfig.tone}
                                label={statusConfig.label}
                              />
                            )}
                          </div>
                          <div style={{ minWidth: 0 }}>
                            {isProcurementLoading ? (
                              <div role='status' aria-busy='true'>
                                <span className='visually-hidden'>Loading</span>
                                <Skeleton width='55%' height={24} />
                                <Skeleton
                                  className='mt-2'
                                  width='35%'
                                  height={14}
                                />
                              </div>
                            ) : (
                              <>
                                <h4 className='mb-1 fw-bold text-dark text-break'>
                                  {categoryLabel} —{' '}
                                  {displayValue(form?.titleProcurement)}
                                </h4>
                                <div className='d-flex flex-wrap align-items-center gap-2 text-muted small'>
                                  <i className='ri-hashtag'></i>
                                  <span>
                                    Procurement ID:{' '}
                                    {displayValue(form?.procurementNumber)}
                                  </span>

                                  <span className='d-none d-md-inline text-secondary opacity-25'>
                                    |
                                  </span>

                                  <i className='ri-calendar-line'></i>
                                  <span>
                                    {formatSubmittedDate(form?.createdDate)}
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className='mt-3 mb-0 border-secondary opacity-10' />
                  </Col>
                </Row>
                <Row className='justify-content-center'>
                  <Col xxl={12}>
                    <Card>
                      <CardBody className='checkout-tab'>
                        <div className='step-arrow-nav mt-n3 mx-n3 mb-2'>
                          <Nav
                            className='nav-tabs nav-tabs-custom nav-success'
                            role='tablist'
                          >
                            <NavItem>
                              <NavLink
                                className={classnames(
                                  {
                                    active: activeTab === 1,
                                    done: activeTab <= 4 && activeTab >= 0,
                                  },
                                  'fs-15  text-uppercase fw-semibold'
                                )}
                                onClick={() => {
                                  toggleTab(1);
                                }}
                                tag='button'
                                type='button'
                              >
                                <i className='ri-store-2-line me-2 align-middle'></i>{' '}
                                Invitation
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink
                                className={classnames(
                                  {
                                    active: activeTab === 4,
                                    done: activeTab <= 4 && activeTab > 3,
                                  },
                                  'fs-15   text-uppercase fw-semibold'
                                )}
                                onClick={() => {
                                  toggleTab(4);
                                }}
                                tag='button'
                                type='button'
                              >
                                <i className='ri-store-2-line me-2 align-middle'></i>{' '}
                                Supporting Document
                                {/* <span className="badge bg-danger align-middle ms-1">
                            2
                          </span> */}
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>

                        <TabContent activeTab={activeTab}>
                          <TabPane tabId={1} id='pills-bill-info'>
                            {isProcurementLoading ? (
                              <>
                                <SkeletonCard
                                  lines={5}
                                  className='border mb-4'
                                />
                                <SkeletonCard
                                  lines={6}
                                  className='border mb-4'
                                />
                                <SkeletonCard lines={4} className='border' />
                              </>
                            ) : (
                              <RequirementTab
                                goNext={() => setactiveTab(2)}
                                ids={ids}
                                form={form}
                                setForm={setForm}
                                handleSaveDraftProc={handleSaveDraftProc}
                                validatedeliveryModal={validatedeliveryModal}
                                errors={errors}
                                error={error}
                                setErrors={setErrors}
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                qtyDeliveryData={qtyDeliveryData}
                                token={token}
                                dataCause={dataCause}
                              />
                            )}
                          </TabPane>

                          <TabPane tabId={4}>
                            <SupportDocumentTab
                              goNext={() => setactiveTab(5)}
                              goBack={() => setactiveTab(1)}
                              ids={ids}
                              form={form}
                              errors={errors}
                              error={error}
                              setErrors={setErrors}
                              isLoading={isLoading}
                              qtyDeliveryData={qtyDeliveryData}
                              token={token}
                            />
                          </TabPane>
                        </TabContent>
                      </CardBody>
                    </Card>
                  </Col>
                  {form.invitationEvaluationStatus === false && (
                    <div className='req-actionbar flex-wrap'>
                      <ActionButton
                        variant='primary'
                        icon='ri-login-box-line'
                        className='ms-auto'
                        onClick={handleConfirmProcess}
                      >
                        Save & Confirm
                      </ActionButton>
                    </div>
                  )}
                </Row>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <ConfirmInvitationModal
        show={confirmModal}
        submitting={isConfirming}
        onConfirm={handleConfirmInvitation}
        onClose={() => setConfirmModal(false)}
      />
    </React.Fragment>
  );
};
export default InvitationEvaluationForm;
